import React from "react";

import ErrorBoundaryView from "./Pages/ErrorBoundaryView";
import logger from "./utilities/logger";
class ErrorBoundary extends React.Component {
  /**
   * constructor - description of method.
   *
   * @param {type} props - description of parameter
   * @return {type} description of return value
   */
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  /**
   * A static method that gets the derived state from an error.
   *
   * @param {error} error - the error object
   * @return {object} an object with the hasError property set to true
   */
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: null, errorInfo: null };
  }

  /**
   * Handle errors that occur during rendering.
   *
   * @param {error} error - the error that occurred
   * @param {object} errorInfo - information about the error
   */
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    logger.log(error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });
  }

  /**
   * Renders the component based on the state.
   *
   * @return {JSX.Element} The rendered UI based on the state.
   */
  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <ErrorBoundaryView data={this.state} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
